<template>
  <showForm
  :fromArchive = "archive"
  :formsesid = "formsid"
  :requiredsubmit = 'false'
  :closedoption = "closeoption"
  :isfieldvalidate = "showpopup"
        type: Boolean,
        default: false
   />
</template>

<script src="./showformComponent.js"></script>
